<template>
  <component
    :is="'h' + level"
    :class="[isCentered && 'text--center']"
  >
    {{ text }}
    <slot />
  </component>
</template>

<script>
  export default {
    props: {
      isCentered: {
        type: Boolean,
        default: false
      },
      text: {
        type: String,
        default: null
      },
      level: {
        type: Number,
        default: 1
      }
    }
  };
</script>

<style lang="scss">
  @import "../../styles/shared/shared";

  h1,
  h2,
  h3 {
    color: $primary;
    line-height: $headings-line-height;
  }

  h1 {
    font-size: 1.75rem;
    margin-bottom: 1.25rem;
    @include minpoint(tablet) {
      font-size: 2.5rem;
    }
  }

  h2 {
    font-size: 1.25rem;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  h4 {
    text-transform: uppercase;
    font-size: $font-size-base;
    margin-bottom: .5rem;
  }

  h5 {
    font-size: $font-size-base;
    color: $primary;
    margin-bottom: 0;
  }
</style>
